import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetMarkByvideoandStdIdQuery, usePostQuizMarkMutation } from '../features/marks/marksApi';
import { useGetQuizQuery } from '../features/quiz/quizApi';

const Quizs = () => {

  const {videoId  }=useParams();
  const {user:loginUser} = useSelector((state) => state.auth);

const {data:quizsList,isLoading,isError,isSuccess}=useGetQuizQuery({videoId :videoId.slice(8)});
const [submitQuizMark,{isLoading:submitLoading,isSuccess:submitSuccess}]=usePostQuizMarkMutation();
const[senData,setSendData]=useState({

})
const[quizWithCheck,setquizWithChek]=useState([]);


useEffect(()=>{
  setquizWithChek(quizsList?.map(q=>({...q, options: q.options.map(op=>({...op,isChecked:false})) })))
},[quizsList])

const handleCheckAnswer=(e,quizId,optionId)=>{


  setquizWithChek(prev=>(prev?.map((q,ind)=>q.id==quizId ? {...q, options:q.options.map(op=>op.id==optionId ?{...op,isChecked:!op.isChecked}:{...op,isChecked:e.target.checked==true ? false :op?.isChecked})}: q)))
 
  

 

}


const[rightAns,setRightAns]=useState(0)

useEffect(()=>{

 

setRightAns(0)
quizWithCheck?.map(q=>{
  q?.options?.map(o=>{
    if(o.isCorrect==true && o.isChecked==true){
      setRightAns(prev=>(prev+1))
    }
  })
})
},[loginUser,quizWithCheck]);

const {data:isQuizAvailable}=useGetMarkByvideoandStdIdQuery({ videoId:quizWithCheck?.[0]?.video_id, stdId:loginUser.id },{skip:!submitSuccess});

useEffect(()=>{
  setSendData(prev=>({...prev,"totalCorrect": rightAns, "mark": Number(rightAns)*5 ,"totalWrong": Number(quizWithCheck?.length) - Number(rightAns),"student_id":loginUser.id,"student_name":loginUser?.name ,"totalQuiz":quizWithCheck?.length ,"totalMark":quizWithCheck?.length*5,"video_id":quizWithCheck?.[0]?.video_id,video_title: quizWithCheck?.[0]?.video_title
}))
},[loginUser,quizWithCheck,rightAns])

const navigate =useNavigate();
useEffect(()=>{
  if(isQuizAvailable?.length > 0){
    navigate('/student/courseplayer')
  }
},[isQuizAvailable])
let content=undefined;

if(isLoading){
  content=<p>Loading............</p>
}
else if(!isLoading && isError){
  content=<p>Something went wrong!</p>

}
else if(!isLoading && !isError && isSuccess && quizsList?.length==0){
  content=<p>No Quiz availabe!</p>

}

else if(!isLoading && !isError && isSuccess  && quizsList?.length > 0){
  content=quizWithCheck?.map((quiz,index)=>( <div key={quiz.id} className="quiz">
  <h4 className="question">Quiz {index+1} - {quiz?.question}</h4>
  <div className="quizOptions">
    {/* Option 1 */}
  {quiz?.options?.map((op,ind)=>(
 <label key={op.id} htmlFor={`option${op.id}_q${quiz.id}`}>
 <input type="checkbox" id={`option${op.id}_q${quiz.id}`} hidden onChange={e=>handleCheckAnswer(e,quiz.id,op.id)} checked={op.isChecked==true} />
 {op?.option}
</label>
  )) }
    
  </div>
</div>))

}


  return (
  <><div>
  
  <section className="py-6 bg-primary">
    <div className="mx-auto max-w-7xl px-5 lg:px-0">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">{quizsList?.[0]?.video_title}
        </h1>
        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
      </div>
      <div className="space-y-8 ">
       {content}
       
      </div>
      <button disabled={submitLoading} className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 " onClick={()=>submitQuizMark({...senData})}>Submit</button>
    </div>
  </section>
</div>
 </>
  )
}

export default Quizs